import { useEffect, useMemo } from 'react';
import { apiBaseUrl } from '../../config';
import { HttpTransportType, HubConnectionBuilder, JsonHubProtocol, LogLevel } from '@microsoft/signalr';
import { useClientMethod, useHub, useHubMethod } from 'react-use-signalr';
import { useBoxes } from 'Contexts/BoxContext';

const UnitBoxDigitalViewSignalR = props => {

    const {
        token,
        companyId,
        requestBody,
        onIncomingData,
    } = props;

    const {
        refreshBoxes,
    } = useBoxes();

    const signalRConnection = useMemo(
        () => {
            const buildHubUrl = companyId
                ? `${apiBaseUrl}/ws/data?companyid=${companyId}`
                : `${apiBaseUrl}/ws/data`;

            const protocol = new JsonHubProtocol();
            const transport = HttpTransportType.WebSockets;

            const options = {
                skipNegotiation: true,
                transport,
                accessTokenFactory: () => token,
                headers: { authorization: token ? `Token ${token}` : `` },
            };

            return new HubConnectionBuilder()
                .withUrl(buildHubUrl, options)
                .withAutomaticReconnect()
                .withHubProtocol(protocol)
                .configureLogging(LogLevel.Information)
                .build();
        }, [token, companyId],
    );

    const {
        hubConnectionState,
        // error
    } = useHub(signalRConnection);
    const {
        invoke,
        // loading,
        // error: errorInvoke
    } = useHubMethod(signalRConnection, 'GetDigitalViewDataForUnits');

    useClientMethod(signalRConnection, 'DigitalViewDataResponse', onIncomingData);

    useEffect(() => {
        if (requestBody && hubConnectionState === 'Connected') {
            invoke(requestBody).then();
        }
    }, [
        requestBody,
        invoke,
        hubConnectionState,
    ]);

    return null;
};

export default UnitBoxDigitalViewSignalR;
